module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-menu', {
    attrs: {
      "transition": "scroll-y-transition",
      "max-width": "290px",
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-left": -40,
      "nudge-top": 25
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": _vm.label,
            "rules": _vm.rules,
            "clearable": _vm.clearable,
            "required": _vm.required,
            "readonly": "",
            "prepend-icon": "event",
            "disabled": _vm.disabled
          },
          model: {
            value: (_vm.dataFormatada),
            callback: function($$v) {
              _vm.dataFormatada = $$v
            },
            expression: "dataFormatada"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menuData),
      callback: function($$v) {
        _vm.menuData = $$v
      },
      expression: "menuData"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "locale": "pt-br",
      "scrollable": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        return _vm.setData()
      }
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8e42440","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-date-month-menu.vue
// module id = 392
// module chunks = 0